import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yourdomain.com';

const productJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'MeVER Chair Pro v2.0',
  description:
    '3Dヘッドレスト・6Dアームレスト・16カ所の調整機構を搭載した最高峰エルゴノミクスチェア。予約限定30%OFF、各色50脚限定。',
  brand: {
    '@type': 'Brand',
    name: 'MeVER',
  },
  url: `${siteUrl}/`,
  image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/41c171b60e2cafe0917fa0547dde8137.jpeg',
  offers: {
    '@type': 'Offer',
    priceCurrency: 'JPY',
    price: '89650',
    priceValidUntil: '2026-03-31',
    availability: 'https://schema.org/LimitedAvailability',
    url: 'https://mever.design/products/mever-chair-pro-ver2',
    seller: {
      '@type': 'Organization',
      name: 'MeVER',
    },
    shippingDetails: {
      '@type': 'OfferShippingDetails',
      shippingRate: {
        '@type': 'MonetaryAmount',
        value: '0',
        currency: 'JPY',
      },
      shippingDestination: {
        '@type': 'DefinedRegion',
        addressCountry: 'JP',
      },
    },
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    reviewCount: '124',
  },
  warranty: '5年保証',
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'MeVER Chair Pro',
  url: `${siteUrl}/`,
  description:
    'MeVER Chair Pro v2.0 新生活応援キャンペーン。予約限定30%OFFで購入できる最高峰エルゴノミクスチェア。',
  inLanguage: 'ja',
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '本当に理由を問わず返品できますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい、商品到着後30日以内であれば理由を問わず返品が可能です。未開封100%、開封済み・未組立75%、開封済み・組立済み50%の返金となります。',
      },
    },
    {
      '@type': 'Question',
      name: '5年保証の内容について',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '購入日から5年間の製品保証が付帯しています。通常使用における故障や不具合が発生した場合、無償で修理または交換いたします。フレーム・ガスシリンダー・リクライニング機構・アームレスト・ヘッドレストなど主要部品が対象です。',
      },
    },
    {
      '@type': 'Question',
      name: '支払い方法は何がありますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'クレジットカード（VISA/MasterCard/JCB/AMEX）、銀行振込、コンビニ決済、Amazon Pay、Paidy（後払い分割払い）に対応しています。',
      },
    },
    {
      '@type': 'Question',
      name: '予約後のキャンセルは可能ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '商品発送前であればキャンセル可能です。キャンセル期限は2026年4月10日（金）23:59まで。キャンセル手数料10%を差し引いた金額を銀行振込にて返金いたします。',
      },
    },
    {
      '@type': 'Question',
      name: '配送時期と送料について',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '予約販売商品は2026年4月下旬より順次発送予定です。送料は全国一律無料です。',
      },
    },
    {
      '@type': 'Question',
      name: '椅子の耐荷重・対応身長を教えてください。',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '耐荷重150kg、対応身長155cm〜195cm、座面高さ調整範囲42cm〜52cm、リクライニング角度90°〜135°です。',
      },
    },
  ],
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'ホーム',
      item: `${siteUrl}/`,
    },
  ],
};

export default function SeoJsonLd() {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];

    [productJsonLd, websiteJsonLd, faqJsonLd, breadcrumbJsonLd].forEach((data) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach((s) => {
        if (document.head.contains(s)) {
          document.head.removeChild(s);
        }
      });
    };
  }, []);

  return null;
}
